import GTMEvents from './gtm-events';

export default GTMEvents;
